import React from "react";
import DriverSchedule from "./DriverSchedule";
import { useAdmin } from "../context/AdminContext";

const StaffSchedule = () => {
  const { hasAccess } = useAdmin();
  const canEditAllStaffSchedules =
    hasAccess("driverSchedule") || hasAccess("createUser") || hasAccess("staffSchedule");

  return (
    <>
      {/* {canViewMySchedule && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", px: 3, pt: 2 }}>
          <Button
            component={RouterLink}
            to="/my-schedule"
            variant="outlined"
            sx={{ textTransform: "none", fontWeight: 600 }}
          >
            My Schedule
          </Button>
        </Box>
      )} */}
      <DriverSchedule
        defaultScope="staff"
        hideScopeToggle
        readOnly={!canEditAllStaffSchedules}
      />
    </>
  );
};

export default StaffSchedule;
